var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Chip, Drawer, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Cancel01Icon, CellsIcon, Delete02Icon, Edit02Icon, InformationCircleIcon, LinkForwardIcon, MapsIcon, MoreHorizontalCircle01Icon, UserGroupIcon } from 'hugeicons-react';
import { useState } from 'react';
import { AppConsts } from '../../../../../application/common/constants/app-consts';
import { useGetPaginatedClientsQuery } from '../../../../../application/features/clients/client-api';
import useTranslate from '../../../../../localization/helpers';
import ProtectedElement from '../../../../components/ProtectedElement';
import SortDrawer from '../../../../components/sort-drawer';
import { Permissions } from '../../../../permissions';
import ActivateClientDialog from '../../clients-grid/client-status/ActivateClient';
import DeactivateClientDialog from '../../clients-grid/client-status/DeActivateClient';
import ClientsToShowMap from '../../clients-grid/clients-to-show';
var ClientTiles = function (_a) {
    var filterClients = _a.filterClients, filterLocations = _a.filterLocations, openSortDrawer = _a.openSortDrawer, setOpenSortDrawer = _a.setOpenSortDrawer, onClientClick = _a.onClientClick, onGetDirections = _a.onGetDirections, handleEditClient = _a.handleEditClient, handleDeleteClient = _a.handleDeleteClient, onShowOnMap = _a.onShowOnMap, mapDrawerOpen = _a.mapDrawerOpen, handleCloseMapDrawer = _a.handleCloseMapDrawer, clientToShowOnMap = _a.clientToShowOnMap;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField;
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:901px) and (max-width:1201px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var _d = __read(useState(null), 2), selectedClient = _d[0], setSelectedClient = _d[1];
    var _e = __read(useState({ isOpen: false, isActive: false }), 2), clientStatusModal = _e[0], setClientStatusModal = _e[1];
    var openClientActivationModal = function (client, isActive) {
        setClientStatusModal({
            client: client,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeClientStatusModal = function () {
        setClientStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var activationModalOpen = clientStatusModal.isOpen && !clientStatusModal.isActive;
    var deActivationModalOpen = clientStatusModal.isOpen && clientStatusModal.isActive;
    var theme = useTheme();
    var handleMenuClick = function (event, client) {
        setAnchorEl(event.currentTarget);
        setSelectedClient(client);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
        setSelectedClient(null);
    };
    var _f = __read(useState({
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined,
        clients: filterClients,
        locations: filterLocations
    }), 2), paginatedClientFilters = _f[0], setPaginatedClientFilters = _f[1];
    var _g = useGetPaginatedClientsQuery({
        page: paginatedClientFilters.page,
        pageSize: paginatedClientFilters.pageSize,
        sortDirection: paginatedClientFilters.sortDirection,
        sortField: paginatedClientFilters.sortField,
        filterField: paginatedClientFilters.filterField,
        filterOperator: paginatedClientFilters.filterOperator,
        filterValue: paginatedClientFilters.filterValue,
        clients: filterClients,
        locations: filterLocations
    }, { refetchOnMountOrArgChange: true }), data = _g.data, isFetching = _g.isFetching;
    var _h = (data !== null && data !== void 0 ? data : {}).items, paginatedClients = _h === void 0 ? [] : _h;
    var handleLoadMore = function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) && paginatedClientFilters.pageSize < data.totalCount) {
            setPaginatedClientFilters(function (prev) { return (__assign(__assign({}, prev), { pageSize: prev.pageSize + AppConsts.DEFAULT_PAGE_SIZE })); });
        }
    };
    var _j = __read(useState(paginatedClientFilters.sortField), 2), sortField = _j[0], setSortField = _j[1];
    var _k = __read(useState(paginatedClientFilters.sortDirection), 2), sortDirection = _k[0], setSortDirection = _k[1];
    var sortOptions = [
        { value: 'name', label: translate('clients.sortOptions.client') },
        { value: 'machines', label: translate('clients.sortOptions.machines') },
        { value: 'contactPersonName', label: translate('clients.sortOptions.contactPerson') },
        { value: 'streetName', label: translate('clients.sortOptions.location') }
    ];
    var getMenuItems = function () {
        if (!selectedClient)
            return [];
        return [
            {
                text: translate('clients.details'),
                icon: InformationCircleIcon,
                color: theme.palette.text.primary,
                onClick: function () {
                    onClientClick(selectedClient.id);
                    handleMenuClose();
                },
                divider: false
            },
            {
                text: translate('clients.directions'),
                icon: LinkForwardIcon,
                color: theme.palette.text.primary,
                onClick: function () {
                    handleMenuClose();
                    onGetDirections(selectedClient);
                },
                divider: false
            },
            {
                text: translate('clients.showOnMap'),
                icon: MapsIcon,
                color: theme.palette.text.primary,
                onClick: function () {
                    handleMenuClose();
                    onShowOnMap(selectedClient);
                },
                divider: true
            },
            {
                text: translate('actions.edit'),
                icon: Edit02Icon,
                color: theme.palette.text.primary,
                onClick: function () {
                    handleMenuClose();
                    handleEditClient(selectedClient.id);
                },
                divider: false,
                permissions: [Permissions.Clients.Update]
            },
            {
                text: translate('actions.delete'),
                icon: Delete02Icon,
                color: theme.palette.error.main,
                onClick: function () {
                    handleMenuClose();
                    handleDeleteClient(selectedClient);
                },
                divider: false,
                permissions: [Permissions.Clients.Delete]
            }
        ];
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { position: 'relative', display: 'flex', flexDirection: 'column', gap: 2, p: '0px 8px 8px 8px', sx: {
                    overflowY: 'auto',
                    maxHeight: isscreen600900Landscape
                        ? 'calc(100svh - 220px)'
                        : isIpadMini || isscreen9001200Landscape
                            ? 'calc(100svh - 267px)'
                            : 'calc(100svh - 240px)'
                }, children: [!isFetching && (paginatedClients === null || paginatedClients === void 0 ? void 0 : paginatedClients.length) === 0 && (_jsxs(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: isscreen600900Landscape ? 0 : 8, px: 2, textAlign: 'center', children: [_jsx(UserGroupIcon, { width: isscreen600900Landscape ? 32 : 48, height: isscreen600900Landscape ? 32 : 48, color: theme.palette.text.disabled }), _jsx(Typography, { variant: 'h6', color: 'text.secondary', mt: 0.5, children: tWithField('validations.notFound', 'common.clients') })] })), paginatedClients.map(function (client) {
                        return (_jsxs(Box, { sx: {
                                p: '8px 12px 16px 12px',
                                width: '100%',
                                boxShadow: theme.customShadows.z8,
                                border: "2px solid ".concat('rgba(255, 255, 255, 1)'),
                                borderRadius: theme.spacing(2),
                                backgroundColor: theme.palette.background.paper,
                                transition: 'border-color 0.3s ease'
                            }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'caption', color: 'text.tertiary', sx: {
                                                maxWidth: '80%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }, children: client.contactPersonName }), _jsx(Box, { display: 'flex', alignItems: 'center', children: _jsx(IconButton, { size: 'small', onClick: function (e) { return handleMenuClick(e, client); }, children: _jsx(MoreHorizontalCircle01Icon, {}) }) }), _jsxs(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleMenuClose, anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'center'
                                            }, transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'center'
                                            }, children: [getMenuItems().map(function (item, index) { return (_jsx(Box, { children: _jsx(ProtectedElement, { permissions: item.permissions || [], children: _jsxs(MenuItem, { onClick: item.onClick, divider: item.divider, sx: { color: item.color }, children: [_jsx(ListItemIcon, { children: item.icon ? (_jsx(item.icon, { fontSize: 20, color: item.color })) : (_jsx(Box, { width: 20 })) }), _jsx(ListItemText, { children: item.text })] }) }) }, index)); }), _jsx(Box, { children: selectedClient && (_jsx(ProtectedElement, { permissions: [Permissions.Clients.Update], children: _jsxs(MenuItem, { divider: false, sx: { color: theme.palette.text.primary }, onClick: function () {
                                                                handleMenuClose();
                                                                if (selectedClient) {
                                                                    openClientActivationModal(selectedClient, selectedClient.isActive);
                                                                }
                                                            }, children: [_jsx(ListItemIcon, { children: _jsx(Switch, { size: 'small', sx: { right: 5 }, checked: selectedClient.isActive, onClick: function (e) { return e.stopPropagation(); }, onChange: function (e) {
                                                                            handleMenuClose();
                                                                            if (selectedClient) {
                                                                                openClientActivationModal(selectedClient, !e.target.checked);
                                                                            }
                                                                        } }) }), _jsx(ListItemText, { children: selectedClient.isActive
                                                                        ? translate('common.deactivate')
                                                                        : translate('common.activate') })] }) })) })] })] }), _jsx(SortDrawer, { open: openSortDrawer, onClose: function () { return setOpenSortDrawer(false); }, sortDirection: sortDirection, setSortDirection: setSortDirection, sortField: sortField, setSortField: setSortField, sortOptions: sortOptions, onApply: function () {
                                        var updatedFilters = __assign(__assign({}, paginatedClientFilters), { sortDirection: sortDirection, sortField: sortField, page: AppConsts.DEFAULT_PAGE_NUMBER });
                                        setPaginatedClientFilters(updatedFilters);
                                        setOpenSortDrawer(false);
                                    }, backdropColor: 'rgba(22, 28, 36, 0.1)' }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', children: [_jsx(Typography, { variant: 'body2', sx: {
                                                        maxWidth: '80%',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }, children: client.name }), _jsx(Chip, { size: 'small', variant: 'soft', color: client.isActive ? 'primary' : 'error', label: client.isActive ? translate('common.active') : translate('common.inactive') })] }), _jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', children: [_jsxs(Typography, { variant: 'caption', color: 'textSecondary', sx: {
                                                        maxWidth: '80%',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }, children: [client.streetName, " ", client.streetNumber, " ", client.postCode, " ", client.city] }), _jsx(Chip, { size: 'small', variant: 'soft', label: client.machines, sx: {
                                                        background: '#919EAB14',
                                                        '& .MuiChip-label': {
                                                            fontSize: '13px',
                                                            fontWeight: 600,
                                                            color: theme.palette.text.secondary,
                                                            padding: '10px'
                                                        }
                                                    }, icon: _jsx(CellsIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                                                            stroke: theme.palette.text.secondary
                                                        } }) })] })] })] }, client.id));
                    }), paginatedClients &&
                        data &&
                        (data === null || data === void 0 ? void 0 : data.totalCount) > 0 &&
                        paginatedClientFilters &&
                        paginatedClientFilters.pageSize < data.totalCount &&
                        !(data.totalCount - paginatedClientFilters.page * paginatedClientFilters.pageSize <
                            0) && (_jsx(Button, { variant: 'outlined', fullWidth: true, onClick: handleLoadMore, disabled: isFetching, children: isFetching
                            ? translate('common.loading')
                            : translate('common.loadMore', {
                                count: data.totalCount -
                                    paginatedClientFilters.page * paginatedClientFilters.pageSize
                            }) }))] }), _jsx(Drawer, { anchor: 'bottom', open: mapDrawerOpen, onClose: handleCloseMapDrawer, slotProps: {
                    paper: {
                        sx: {
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden'
                        }
                    }
                }, variant: 'temporary', children: clientToShowOnMap && (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: {
                                display: 'flex',
                                width: '100%',
                                borderRadius: '16px',
                                justifyContent: 'space-between',
                                padding: '16px 20px 16px 20px'
                            }, children: [_jsxs(Typography, { variant: 'h6', children: [clientToShowOnMap.name, " ", translate('common.location')] }), _jsx(IconButton, { onClick: handleCloseMapDrawer, children: _jsx(Cancel01Icon, {}) })] }), _jsx(Box, { height: '100%', children: _jsx(ClientsToShowMap, { clients: [clientToShowOnMap] }) })] })) }), activationModalOpen && (_jsx(ActivateClientDialog, { client: clientStatusModal.client, isOpen: activationModalOpen, onClose: closeClientStatusModal })), deActivationModalOpen && (_jsx(DeactivateClientDialog, { client: clientStatusModal.client, isOpen: deActivationModalOpen, onClose: closeClientStatusModal }))] }));
};
export default ClientTiles;
